module.exports = __webpack_public_path__ + "static/media/keyboard-arrow-right.11ea5efb.svg";